import { CustomStyleDefinition } from '../models';

// Define a mapping of custom style properties to their corresponding Tailwind CSS class prefixes.
const ALLOWED_STYLE_MAPPING: Record<keyof CustomStyleDefinition, string> = {
  textColor: 'text', // Mapping for text color
  textColorDark: 'dark:text', // Mapping for dark mode text color
  bgColor: 'bg', // Mapping for background color
};

/**
 * Converts the provided custom style definitions into their respective Tailwind CSS class names.
 *
 * @param styles - The custom style definitions to be converted.
 * @returns A space-separated string of Tailwind CSS class names.
 */
export const getClassNamesFromStyles = (styles: CustomStyleDefinition): string =>
  Object.entries(styles)
    .map(([property, value]) => {
      // Retrieve the Tailwind CSS class prefix for the given property from the mapping
      const tailwindClassPrefix = ALLOWED_STYLE_MAPPING[property as keyof CustomStyleDefinition];

      // Convert the custom style property and value to the Tailwind CSS class name format
      return tailwindClassPrefix ? `${tailwindClassPrefix}-${value}` : '';
    })

    .filter(Boolean) // Remove any undefined or empty mappings
    .join(' '); // Join the class names into a space-separated string
